import { contractServiceClient } from '@lib/documentServiceClient';
import { createSnapshotService } from '@workpay/ds-shared/services/snapshotService';

export const dsSnapshotService = createSnapshotService(contractServiceClient);
